import React from 'react'

import { NavTab } from '../../../types/graphql'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

export const NavTabBar: React.FC<{
  freezeTabId?: string
  tabs: NavTab[]
  wrapItems?: boolean
  isReadyToInteract?: boolean
}> = ({ freezeTabId, tabs, wrapItems = false, isReadyToInteract = true }) => {
  const viewModel = useViewModel({ freezeTabId, tabs, wrapItems, isReadyToInteract })
  return <Template {...viewModel} />
}
